define('load-modules',[],function() {

    var loadModules = function(options) {
        options = options || {};

        var modules = options.modules || [];

        return new Promise(function(resolve) {

            if (!modules.length) {
                resolve();
                return;
            }

            require(modules, function() {
                resolve();
            });

        });
    };

    return loadModules;
});

